import { createFileRoute } from "@tanstack/react-router";
import SaintVsNeurostar from "@/pages/SaintVsNeurostar";
export const Route = createFileRoute("/saint-vs-neurostar")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "SAINT® vs NeuroStar TMS | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Compare SAINT® TMS to NeuroStar: 5 days vs 36 sessions, fMRI targeting, placebo-controlled results. Verified SAINT Provider in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "SAINT® vs NeuroStar TMS | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Compare SAINT® TMS to NeuroStar: 5 days vs 36 sessions, fMRI targeting, placebo-controlled results. Verified SAINT Provider in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/saint-vs-neurostar",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/saint-vs-neurostar",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <SaintVsNeurostar />;
}
